// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      temp_humidity: "Temperature & Humidity",
      temp_humidity_desc: "This sensor measures ambient temperature and humidity.",
      gps_location: "GPS Location",
      gps_location_desc: "This sensor provides precise location tracking.",
      air_quality: "Air Quality",
      air_quality_desc: "Monitors the air quality including pollutants and other harmful substances.",
      weather_monitoring: "Weather Monitoring",
      weather_monitoring_desc: "Tracks weather conditions in the area, such as solar radiation, temperature, humidity, and precipitation.",
      industrial_monitoring: "Industrial Monitoring",
      industrial_monitoring_desc: "Observes various industrial parameters for efficiency and safety.",
      new_sensor: "Another Sensor",
      new_sensor_desc: "Request for another sensor not listed.",
      camera_tracking: "Camera Tracking",
      camera_tracking_desc: "Tracks movement and other activities using cameras.",
      smoke_fire: "Smoke & Fire",
      contactAllowedLabel: "Allow contact via WhatsApp or Phone",
      phoneLabel: "Phone Number",
      smoke_fire_desc: "Detects smoke and fire in the area.",
        vibration: "Vibration",
        vibration_desc: "Monitors machinery and equipment vibration",
        pressure: "Pressure",
        pressure_desc: "Measures pressure in industrial systems.",
        liquid_level: "Liquid Level",
        liquid_level_desc: "Monitors liquid level in tanks and containers.",
        noise: "Noise",
        noise_desc: "Measures noise level in the area.",
        exploreOurSensors: "Explore Our Sensors",
      chooseSensorSubtitle: "Choose a sensor to learn more and schedule a meeting for further discussion.",
      sensorDetailFormTitle: "Sensor Detail Submission",
      sensorDetailFormSubtitle: "Tell us more about your project and sensor requirements.",
      scheduleMeetingTitle: "Schedule a Meeting",
      scheduleMeetingSubtitle: "Select a convenient time slot for our meeting.",
      contactSoonMessageTitle: "Thank You!",
      contactSoonMessage: "Thank you for your interest. We will contact you as soon as possible.",
      backButton: "Back",
      "detailsSubmittedSuccessTitle": "Details submitted successfully.",
      "detailsSubmittedSuccessDesc": "We've received your details. You can now schedule a call.",
      "errorOccurredTitle": "An error occurred.",
      "errorOccurredDesc": "Unable to submit your details. Please try again.",
      "problemLabel": "Problem you want to solve",
      "problemPlaceholder": "Describe your problem",
      "numSensorsLabel": "Number of Sensors",
      "selectOption": "Select option",
      "additionalCommentsLabel": "Additional Comments",
      "additionalCommentsPlaceholder": "Any additional comments or questions",
      "next": "Next"
    }
  },
  es: {
    translation: {
      temp_humidity: "Temperatura y Humedad",
      temp_humidity_desc: "Este sensor mide la temperatura y humedad ambiental.",
      gps_location: "Ubicación GPS",
      gps_location_desc: "Este sensor proporciona seguimiento de ubicación preciso.",
      air_quality: "Calidad del aire",
      air_quality_desc: "Monitorea la calidad del aire incluyendo contaminantes y otras sustancias nocivas.",
      weather_monitoring: "Monitoreo del clima",
      weather_monitoring_desc: "Rastrea condiciones climáticas de la zona, como radiación solar, temperatura, humedad y precipitación.",
      industrial_monitoring: "Monitoreo Industrial",
      industrial_monitoring_desc: "Observa varios parámetros industriales para eficiencia y seguridad.",
      new_sensor: "Otro Sensor",
      new_sensor_desc: "Solicita otro sensor no listado.",
      camera_tracking: "Seguimiento por Cámara",
      camera_tracking_desc: "Rastrea movimiento y otras actividades usando cámaras.",
      smoke_fire: "Humo y Fuego",
      smoke_fire_desc: "Detecta humo y fuego en el área.",
      vibration: "Vibración",
      vibration_desc: "Monitorear la vibración de maquinaria y equipos",
      pressure: "Presión",
      pressure_desc: "Mide la presión en sistemas industriales.",
      liquid_level: "Nivel de Líquido",
      liquid_level_desc: "Monitorea el nivel de líquido en tanques y contenedores.",
      noise: "Ruido",
      noise_desc: "Mide el nivel de ruido en el área.",
      phoneLabel: "Número de Teléfono",
      contactAllowedLabel: "Permitir contacto por WhatsApp o Teléfono",
      exploreOurSensors: "Explora nuestros sensores",
      chooseSensorSubtitle: "Elige un sensor para obtener más información y programar una reunión para discutir más detalles.",
      sensorDetailFormTitle: "Envío de detalles del sensor",
      sensorDetailFormSubtitle: "Cuéntanos más sobre tu proyecto y los requisitos del sensor.",
      scheduleMeetingTitle: "Programar una reunión",
      scheduleMeetingSubtitle: "Seleccione un horario conveniente para nuestra reunión.",
      contactSoonMessageTitle: "¡Gracias!",
      contactSoonMessage: "Gracias por su interés. Nos pondremos en contacto con usted lo antes posible.",
      backButton: "Volver",
      "detailsSubmittedSuccessTitle": "Detalles enviados con éxito.",
      "detailsSubmittedSuccessDesc": "Hemos recibido tus datos. Ahora puedes programar una llamada.",
      "errorOccurredTitle": "Ocurrió un error.",
      "errorOccurredDesc": "No se pudieron enviar tus detalles. Por favor, inténtalo de nuevo.",
      "problemLabel": "Problema que quieres resolver",
      "problemPlaceholder": "Describe tu problema",
      "numSensorsLabel": "Número de sensores",
      "selectOption": "Selecciona una opción",
      "additionalCommentsLabel": "Comentarios adicionales",
      "additionalCommentsPlaceholder": "Cualquier comentario o pregunta adicional",
      "next": "Siguiente"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;